import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import SearchSimpleField from 'components/FormFieldsSimple/SearchSimpleField';
import { debounce } from 'utils/debounce';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class SearchField extends Component {
  static propTypes = {
    ...fieldPropTypes,
    onInputChange: PropTypes.func,
    getSuggestionLabel: PropTypes.func,
    getInputPostfix: PropTypes.func,
    mapExternalValueToInput: PropTypes.func,
  };

  static defaultProps = {
    onInputChange: Function.prototype,
  };

  timerId;

  handleChange = (value) => {
    const { input } = this.props;
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    this.timerId = setTimeout(() => {
      input.onChange(value);
    }, 800);
  };

  render() {
    const { input, onSuggestionSelectedCallback } = this.props;
    const propsToPass = { ...this.props };

    if (propsToPass.tooltipFor) {
      delete propsToPass.tooltipFor;
    }
    if (propsToPass.tooltipInfo) {
      delete propsToPass.tooltipInfo;
    }

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <SearchSimpleField
          {...propsToPass}
          onSuggestionSelectedCallback={(suggestion) =>
            debounce(onSuggestionSelectedCallback(suggestion), 300)
          }
          onChange={this.handleChange}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          value={input.value}
        />
      </ReduxFormElementWrapper>
    );
  }
}
